var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9.2375 5.7356L9.2375 13.8323C9.2375 14.2388 9.5787 14.5684 9.9996 14.5684C10.4205 14.5684 10.7617 14.2388 10.7617 13.8323L10.7617 5.7356C10.7617 5.3291 10.4205 4.9995 9.9996 4.9995C9.5787 4.9995 9.2375 5.3291 9.2375 5.7356Z",
    fill: "#FF3232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5689 12.6803L6.3799 9.6004C6.0643 9.2955 5.5524 9.2955 5.2368 9.6004C4.9211 9.9053 4.9211 10.3996 5.2368 10.7045L9.4611 14.7844C9.7587 15.0719 10.2413 15.0719 10.5389 14.7844L14.7632 10.7045C15.0789 10.3996 15.0789 9.9053 14.7632 9.6004C14.4476 9.2955 13.9357 9.2955 13.6201 9.6004L10.4311 12.6803C10.193 12.9103 9.807 12.9103 9.5689 12.6803Z",
    fill: "#FF3232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownRed);
export default __webpack_public_path__ + "static/media/arrow-down-red.4f143241b9ca221fd9aa5b371d3fb591.svg";
export { ForwardRef as ReactComponent };